export default function getFontSize(textLength: number, minFontSize: number, maxFontSize: number, minTextLength: number, maxTextLength: number) {
    if (textLength <= minTextLength)
        return maxFontSize;

    if (textLength >= maxTextLength)
        return minFontSize;

    return maxFontSize - (textLength - minTextLength) / (maxTextLength - minTextLength) * (maxFontSize - minFontSize);
}